import { makeCRUDSlice } from 'redux/crudCreator';
import { MODEL_NAME, centreServicesActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, centreServicesActions);

export default slice.reducer;
